import React, { useState } from 'react';
import Layout from '../Layout';
import { LiaCheckSolid } from "react-icons/lia";
import { NavLink } from 'react-router-dom';
import Modal from "../Components/Common/Modal.jsx";
import { IoMdCheckmarkCircleOutline } from "react-icons/io";

export default function Plans() {

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalTitle, setModalTitle] = useState('');
  const [modalData, setModalData] = useState(null);

  const cards = [
    {
      title: "Silver Gold",
      description: "This is a basic plan. This plan contains this.",
      price: "2499",
      icon: <LiaCheckSolid />,
      listItems: [
        "Home loan",
        "Lap loan",
        "Parsonal loan",
        "Business loan",
        "Od loan",
        "Cc loan",
        "Mudra loan",
        "Pmegp loan",
        "Msme loan",
        "Car loan",
        "Old car loan",
        "Online Insurance",
        "Online credit card",
        "Instant RM support",
        "Monthly payout",
        "Incl 18% GST"
      ]

    }, {
      title: "Silver Platinum",
      description: "This is a basic plan. This plan contains this.",
      price: "4999",
      icon: <LiaCheckSolid />,
      offer: true,
      offermessage: "Limited Time Deal!",
      listItems: [
        "Home loan",
        "Lap loan",
        "Parsonal loan",
        "Business loan",
        "Od loan",
        "Cc loan",
        "Mudra loan",
        "Pmegp loan",
        "Msme loan",
        "Car loan",
        "Old car loan",
        "Online Insurance (all types)",
        "Online credit card",
        "CA all service (GST, ITR, TRADE LICENCE)",
        "Instant RM support",
        "2 weeks payout provide"
      ]
    },
    {
      title: "Golden",
      description: "This is a premium plan. This plan contains more features.",
      price: "11999",
      icon: <LiaCheckSolid />,
      listItems: [
        "Home loan",
        "Lap loan",
        "Parsonal loan",
        "Business loan",
        "Od loan",
        "Cc loan",
        "Mudra loan",
        "Pmegp loan",
        "Msme loan",
        "Car loan",
        "Old car loan",
        "Online Insurance (all types)",
        "Online credit card",
        "Aadhaar card pan card parsonal loan direct login",
        "CA all service (GST, ITR, TRADE LICENCE)",
        "Demat account, zero balance account opening, saving account direct login",
        "Instant RM support",
        "What's up group",
        "Instant payout"
      ]
    },
    {
      title: "Golden Jubilee",
      description: "This is an advanced plan with all features included.",
      price: "15999",
      icon: <LiaCheckSolid />,
      listItems: [
        "Home loan",
        "Lap loan",
        "Parsonal loan",
        "Business loan",
        "Od loan",
        "Cc loan",
        "Mudra loan",
        "Pmegp loan",
        "Msme loan",
        "Car loan",
        "Old car loan",
        "Online Insurance (all types)",
        "Online credit card",
        "Aadhaar card pan card parsonal loan direct login",
        "CA all service (GST, ITR, TRADE LICENCE)",
        "Aadhaar card and pan card correction, IRCTC service",
        "Demat account, zero balance account opening, saving account direct login",
        "Instant RM support and director support",
        "Company legal stamp paper, t-shirt, banner, catalogue, all Material by courier deliver",
        "What's up group",
        "Instant payout"
      ]
    },
  ];

  const openModalByKey = (key) => {
    const selected = cards[key];
    if (selected) {
      setModalTitle(selected.title);
      setModalData(selected);
      setIsModalOpen(true);
    }
  };

  return (
    <>

      <Layout>

        <section className="banner org_clr">
          <div className="container ">
            <div className="row gy-4 gy-sm-0 align-items-center justifyCenter">
              <div className="col-12  col-sm-12">
                <div className="banner__content">
                  <h1 className="banner__title display-4 wow fadeInLeft textCenter" data-wow-duration="0.8s">Pricing table template</h1>
                </div>
              </div>

            </div>
          </div>
        </section>

        <div className="tp-page-area sec-mar">
          <div className="container-fluid custom-container">
            <div className="row">
              <div className="col-xl-12">
                <div className="tp-page-content">
                  <div className="tp-page-post">
                    <div data-elementor-type="wp-page" data-elementor-id="49" className="elementor elementor-49">
                      <div className="elementor-element elementor-element-0b613d3 e-con-full e-flex e-con e-parent" data-id="0b613d3" data-element_type="container">
                        <div className="elementor-element elementor-element-67f21b7 elementor-widget elementor-widget-tp-services" data-id="67f21b7" data-element_type="widget" data-widget_type="tp-services.default">
                          <div className="elementor-widget-container">



                            <section className="feature feature--tertiary section">
                              <div className="container">
                                <div className="row g-3 g-sm-2 g-md-3 g-xxl-4">
                                  {cards.map((card, index) => (

                                    <div className="col-12 col-sm-6 col-xl-4" >
                                      <div className="c card card--custom gap-0 cus_align wow fadeInUp crd_hvr cardHoverBtnClr cstm_plan_card" data-wow-duration="0.8s">

                                        {card.offer && (
                                          <div className="exclusivehd">
                                            <span>{card.offermessage || 'Special Offer Limited Time'}</span>
                                          </div>
                                        )}

                                        <div className={`planCardUpper ${card.offer ? 'exclusivehdMrgT' : ''}`}>
                                          <h4>
                                            <NavLink to={"/plans"}
                                              className="crdtCn">
                                              {card.title}
                                            </NavLink>
                                          </h4>
                                          <div className='crdPrcN'>
                                            <h2>₹ {card.price}</h2>&nbsp;/&nbsp;<h7>Incl. 18% GST</h7>
                                          </div>
                                        </div>

                                        <div className="planModal-lists">
                                          <ul>
                                            {card.listItems.slice(0, 5).map((item, idx) => (
                                              <li key={idx}>
                                                <div className='divCheck_price'>
                                                  <IoMdCheckmarkCircleOutline className='check_price' />
                                                </div>
                                                <div className='plandetatils_text'>
                                                  <span>{item}</span>
                                                </div>
                                              </li>
                                            ))}
                                          </ul>
                                        </div>


                                        <div className="btn-cta btnPlansCrd">
                                          <button
                                            className="btn_clr plan_applyBtn"
                                            onClick={() => openModalByKey(index)}
                                          >See Details</button>

                                          <NavLink
                                            to="/contactUs"
                                            className="btn_clr plan_applyBtn">
                                            Apply
                                          </NavLink>

                                        </div>

                                      </div>
                                    </div>

                                  ))}

                                </div>
                              </div>
                            </section>



                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


        <Modal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          title={modalTitle}
          data={modalData}
        />


      </Layout>
    </>
  )
}
